// The create-item wizard and the edit-page lifecycle track.
// Everything is delegated so it survives Turbo navigation, and the form still
// posts fine without JS (the steps just all show at once).

const currentStep = () => {
  const open = document.querySelector('.wizard-step:not([hidden])')
  return open ? Number(open.dataset.step) : 1
}

const saleMode = () => {
  const checked = document.querySelector('input[name="item[sale_mode]"]:checked')
  return checked ? checked.value : 'regular'
}

// Step 3 renders the store card the answers will produce.
const renderPreview = () => {
  const name = document.getElementById('item_name').value || 'Your item'
  const cat = document.getElementById('item_category')
  const price = saleMode() === 'limited'
    ? document.getElementById('item_limited_price').value
    : document.getElementById('item_price').value

  document.getElementById('wp-name').textContent = name
  document.getElementById('wp-cat').textContent =
    cat.options[cat.selectedIndex] ? cat.options[cat.selectedIndex].text : ''
  document.getElementById('wp-price').textContent =
    saleMode() === 'show' ? 'Not for sale' : `$${Number(price || 0).toLocaleString()}`

  const sash = document.getElementById('wp-sash')
  const label = document.getElementById('wp-sash-label')
  const limitedNote = document.getElementById('wp-note-limited')
  sash.className = 'item-sash item-sash-none'
  label.innerHTML = '&nbsp;'
  limitedNote.hidden = true
  if (saleMode() === 'limited') {
    const run = document.getElementById('item_limited_stock_max').value || 0
    sash.className = 'item-sash item-sash-limited'
    label.textContent = `Limited · ${run} of ${run} left`
    limitedNote.hidden = false
  }

  const file = document.querySelector('#item-wizard input[type=file]')
  if (file && file.files && file.files[0]) {
    document.getElementById('wp-img').src = URL.createObjectURL(file.files[0])
  }
}

const showStep = (n) => {
  document.querySelectorAll('.wizard-step').forEach((s) => {
    s.hidden = s.dataset.step !== String(n)
  })
  document.querySelectorAll('[data-step-dot]').forEach((d) => {
    const dn = Number(d.dataset.stepDot)
    d.classList.toggle('wizard-now', dn === n)
    d.classList.toggle('wizard-done', dn < n)
  })
  document.getElementById('wizard-back').hidden = n === 1
  document.getElementById('wizard-next').hidden = n === 3
  document.getElementById('wizard-submit').hidden = n !== 3
  if (n === 3) renderPreview()
}

// The current step's fields must be valid before Next moves on: catching a
// forgotten name/description/image here beats a server round-trip that also
// wipes the chosen file (browsers never repopulate file inputs).
const stepValid = () => {
  const open = document.querySelector('.wizard-step:not([hidden])')
  if (!open) return true
  for (const field of open.querySelectorAll('input, textarea, select')) {
    if (field.checkValidity()) continue
    if (field.type === 'file') {
      const error = document.getElementById('image_error')
      if (error) { error.textContent = 'Pick an image first.'; error.style.display = '' }
    } else {
      field.reportValidity()
    }
    return false
  }
  return true
}

document.addEventListener('click', (event) => {
  if (event.target.closest('#wizard-next') && stepValid()) showStep(currentStep() + 1)
  if (event.target.closest('#wizard-back')) showStep(currentStep() - 1)

  // Edit page: the one-way confirmation panel for opening trading.
  if (event.target.closest('#open-trading-reveal')) {
    const panel = document.getElementById('open-trading-confirm')
    panel.hidden = !panel.hidden
  }
})

// A required field on a hidden step makes the browser refuse the submit
// *silently* (it can't focus something invisible). Reveal the offending step
// and say what's wrong instead — this was the "I can't upload items" bug.
document.addEventListener('invalid', (event) => {
  const step = event.target.closest('.wizard-step')
  if (!step) return
  if (step.hidden) showStep(Number(step.dataset.step))
  if (event.target.type === 'file') {
    event.preventDefault() // no native bubble on a display:none input
    const error = document.getElementById('image_error')
    if (error) { error.textContent = 'Pick an image first.'; error.style.display = '' }
  } else {
    setTimeout(() => event.target.reportValidity(), 0)
  }
}, true)

// Step 2's option cards light up with their radio, and only the chosen
// mode's fields show.
document.addEventListener('change', (event) => {
  if (!event.target.matches('input[name="item[sale_mode]"]')) return
  document.querySelectorAll('.sale-mode-card').forEach((card) => {
    const on = card.querySelector('input[type=radio]').checked
    card.classList.toggle('sale-mode-on', on)
    const body = card.querySelector('.sale-mode-body')
    if (body) body.hidden = !on
  })
})
